import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";

export type GetLomdaV3ResponseType = InferResponseType<
    (typeof client.api.storage)["lomda-v3"][":lomdaId"]["$get"],
    200
>;

export const lomdaV3QueryKey = (lomdaId: string) => ["get-lomda-v3", lomdaId];

export const useGetLomdaV3 = (enabled: boolean, lomdaId: string) => {
    const query = useQuery({
        enabled,
        queryKey: lomdaV3QueryKey(lomdaId),
        queryFn: async () => {
            const response = await client.api.storage["lomda-v3"][
                ":lomdaId"
            ].$get({ param: { lomdaId } });

            if (!response.ok) throw new Error("Failed to fetch lomdaV3");

            const { data } = await response.json();
            return { data };
        },
    });

    return query;
};
